<!-- My Bid History -->
<div class="card">
  <div class="card-header border-0 pt-6">
    <div class="card-title">
      <div class="d-flex align-items-center my-1">
        <i class="ki-duotone ki-chart-line-up fs-2 me-3">
          <span class="path1"></span>
          <span class="path2"></span>
        </i>
        <h3 class="fw-bold m-0">MY BID HISTORY</h3>
      </div>
    </div>
    <div class="card-toolbar">
      <div class="d-flex justify-content-end" data-kt-user-table-toolbar="base">
        <!-- Cancel All Bids Button - shown only when bids are selected -->
        <button
          *ngIf="selectedBids.length > 0"
          type="button"
          class="btn btn-danger btn-sm me-3"
          (click)="cancelAllSelectedBids()">
          <i class="ki-duotone ki-cross fs-2">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          Cancel All Bids ({{ selectedBids.length }})
        </button>

        <button type="button" class="btn btn-primary btn-sm me-3" (click)="toggleFilters()">
          <i class="ki-duotone ki-filter fs-2">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          Filter
          <span *ngIf="activeFiltersCount > 0" class="badge badge-danger ms-2">{{ activeFiltersCount }}</span>
        </button>
        <button type="button" class="btn btn-light btn-sm" (click)="clearFilters()">
          <i class="ki-duotone ki-cross fs-2">
            <span class="path1"></span>
          </i>
          Reset
        </button>
      </div>
    </div>
  </div>

  <!-- Filters Section -->
  <div *ngIf="showFiltersForm" class="card-body border-top">
    <div class="row g-4">
      <!-- Bid Order Date -->
      <div class="col-md-3">
        <label class="form-label fw-semibold">Bid Order Date</label>
        <div class="row g-2">
          <div class="col-6">
            <input type="date" class="form-control form-control-sm"
                   [(ngModel)]="filters.bid_order_date_from"
                   placeholder="From">
          </div>
          <div class="col-6">
            <input type="date" class="form-control form-control-sm"
                   [(ngModel)]="filters.bid_order_date_to"
                   placeholder="To">
          </div>
        </div>
      </div>

      <!-- Auction Date -->
      <div class="col-md-3">
        <label class="form-label fw-semibold">Auction Date</label>
        <div class="row g-2">
          <div class="col-6">
            <input type="date" class="form-control form-control-sm"
                   [(ngModel)]="filters.auction_date_from"
                   placeholder="From">
          </div>
          <div class="col-6">
            <input type="date" class="form-control form-control-sm"
                   [(ngModel)]="filters.auction_date_to"
                   placeholder="To">
          </div>
        </div>
      </div>

      <!-- Auction Hall -->
      <div class="col-md-2">
        <label class="form-label fw-semibold">Auction Hall</label>
        <select class="form-select form-select-sm" [(ngModel)]="filters.auction_hall">
          <option *ngFor="let option of auctionHallOptions" [value]="option.value">
            {{ option.label }}
          </option>
        </select>
      </div>

      <!-- Bid Status -->
      <div class="col-md-2">
        <label class="form-label fw-semibold">Bid Status</label>
        <select class="form-select form-select-sm" [(ngModel)]="filters.bid_status">
          <option *ngFor="let option of bidStatusOptions" [value]="option.value">
            {{ option.label }}
          </option>
        </select>
      </div>

      <!-- Lot No -->
      <div class="col-md-2">
        <label class="form-label fw-semibold">Lot No.</label>
        <input type="text" class="form-control form-control-sm"
               [(ngModel)]="filters.lot_no"
               placeholder="Lot No, with Comma Separated">
      </div>
    </div>

    <!-- Keyword Search -->
    <div class="row g-4 mt-2">
      <div class="col-md-6">
        <label class="form-label fw-semibold">Keyword Search</label>
        <input type="text" class="form-control form-control-sm"
               [(ngModel)]="filters.keyword_search"
               placeholder="Make, Model, Lot No, Vin, Year">
      </div>
    </div>

    <!-- Filter Actions -->
    <div class="row mt-4">
      <div class="col-12">
        <button type="button" class="btn btn-primary btn-sm me-3" (click)="applyFilters()">
          <i class="ki-duotone ki-magnifier fs-2">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          Search
        </button>
        <button type="button" class="btn btn-light btn-sm" (click)="clearFilters()">
          <i class="ki-duotone ki-cross fs-2">
            <span class="path1"></span>
          </i>
          Reset
        </button>
      </div>
    </div>
  </div>

  <!-- Results Summary -->
  <div class="card-body pt-0">
    <div class="d-flex justify-content-between align-items-center mb-4">
      <div class="text-muted">
        <strong>Total Records Found: {{ paginationInfo.total }}</strong>
      </div>
      <div class="d-flex align-items-center">
        <span class="text-muted me-3">Records Per Page</span>
        <select class="form-select form-select-sm w-auto">
          <option value="20">20</option>
          <option value="50">50</option>
          <option value="100">100</option>
        </select>
      </div>
    </div>

    <!-- Loading State -->
    <div *ngIf="isLoading" class="text-center py-5">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <p class="text-muted mt-3">Loading bids...</p>
    </div>

    <!-- No Data State -->
    <div *ngIf="!isLoading && bids.length === 0" class="text-center py-5">
      <i class="ki-duotone ki-file-deleted fs-3x text-muted mb-3">
        <span class="path1"></span>
        <span class="path2"></span>
      </i>
      <h5 class="text-muted">No bids found</h5>
      <p class="text-muted">Try adjusting your search criteria or filters.</p>
    </div>

    <!-- Bids Table -->
    <div *ngIf="!isLoading && bids.length > 0" class="table-responsive">
      <table class="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3">
        <thead>
          <tr class="fw-bold text-muted bg-light">
            <th class="min-w-50px text-center">
              <div class="form-check form-check-sm form-check-custom form-check-solid">
                <input
                  class="form-check-input"
                  type="checkbox"
                  [checked]="isAllSelected()"
                  [indeterminate]="isIndeterminate()"
                  (change)="toggleAllSelection($event)">
              </div>
            </th>
            <th class="min-w-50px text-center">#</th>
            <th class="min-w-120px">Bid Order Date</th>
            <th class="min-w-120px">Auction Date</th>
            <th class="min-w-100px">Lot No. Auction</th>
            <th class="min-w-80px">Group (Unit)</th>
            <th class="min-w-150px">Make/Car</th>
            <th class="min-w-100px">Bid Start Price (JPY)</th>
            <th class="min-w-100px">Your Bid Offer (JPY)</th>
            <th class="min-w-100px">Result (JPY)</th>
            <th class="min-w-80px text-center">Status</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let bid of bids; trackBy: trackByFn; let i = index">
            <tr class="bid-row">
              <td class="text-center">
                <div class="form-check form-check-sm form-check-custom form-check-solid">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    [value]="bid._id"
                    [checked]="isSelected(bid._id)"
                    (change)="toggleSelection(bid._id, $event)">
                </div>
              </td>
              <td class="text-center">
                <span class="fw-bold">{{ i + 1 }}</span>
              </td>
              <td>
                <div class="d-flex flex-column">
                  <span class="fw-semibold">{{ formatDate(bid.created_at) }}</span>
                  <small class="text-muted">{{ formatDateTime(bid.created_at).split(',')[1] }}</small>
                </div>
              </td>
              <td>
                <div class="d-flex flex-column">
                  <span class="fw-semibold">{{ formatDate(bid.car.auction_date) }}</span>
                  <small class="text-muted">{{ formatDateTime(bid.car.auction_date).split(',')[1] }}</small>
                </div>
              </td>
              <td>
                <div class="d-flex flex-column">
                  <span class="fw-bold text-primary">{{ bid.car.lot_no }}</span>
                  <small class="text-muted">{{ bid.car.parsed_data?.hallname || 'N/A' }}</small>
                </div>
              </td>
              <td>
                <div class="d-flex flex-column">
                  <span class="badge badge-light-info mb-1">{{ bid.group }}</span>
                  <small class="text-muted fw-semibold">{{ getUnitDisplayText(bid) }}</small>
                </div>
              </td>
              <td>
                <div class="d-flex align-items-center">
                  <div class="symbol symbol-50px me-3">
                    <img [src]="getMainImage(bid.car)"
                         [alt]="bid.car.name"
                         class="symbol-label"
                         onerror="this.src='assets/media/stock/600x400/img-1.jpg'">
                  </div>
                  <div class="d-flex flex-column">
                    <span class="fw-bold text-gray-800">{{ bid.car.company_name }}</span>
                    <span class="text-muted">{{ bid.car.name }}</span>
                    <small class="text-muted">{{ bid.car.year }} | {{ bid.car.engine }}cc</small>
                  </div>
                </div>
              </td>
              <td>
                <span class="fw-bold">{{ formatCurrency(parseInt(bid.car.price), 'JPY') }}</span>
              </td>
              <td>
                <span class="fw-bold text-primary">{{ formatCurrency(bid.bid_amount, bid.currency) }}</span>
              </td>
              <td>
                <span class="fw-bold">{{ formatCurrency(bid.result_amount || 0, 'JPY') }}</span>
              </td>
              <td class="text-center">
                <span class="badge" [class]="getStatusBadgeClass(bid.status)">
                  {{ bid.status | titlecase }}
                </span>
              </td>
            </tr>
            <!-- Message row - shown only if bid has a message -->
            <tr *ngIf="bid.message && bid.message.trim()" class="bid-message-row">
              <td colspan="11" class="bid-message-cell">
                <div class="bid-message-container">
                  <div class="bid-message-content">
                    <i class="ki-duotone ki-message-text-2 fs-4 text-primary me-2">
                      <span class="path1"></span>
                      <span class="path2"></span>
                      <span class="path3"></span>
                    </i>
                    <span class="text-muted fw-semibold">Comment:</span>
                    <span class="ms-2">{{ bid.message }}</span>
                  </div>
                </div>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>

    <!-- Pagination -->
    <div *ngIf="!isLoading && bids.length > 0" class="">
      <!-- <div class="text-muted">
        Showing {{ (paginationInfo.currentPage - 1) * paginationInfo.perPage + 1 }} to
        {{ Math.min(paginationInfo.currentPage * paginationInfo.perPage, paginationInfo.total) }}
        of {{ paginationInfo.total }} entries
      </div> -->

      <app-pagination
        [paginationInfo]="paginationInfo"
        [loading]="isLoading"
        (pageChange)="onPageChange($event)">
      </app-pagination>
    </div>
  </div>
</div>
